import * as tslib_1 from "tslib";
import selectFolder from './selectFolder';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { lazyRemoveFavoriteFolder } from 'owa-mail-favorites-store';
import { favoritesStore } from 'owa-favorites';
import { getFolderIdForSelectedNode } from 'owa-mail-folder-forest-store';
import { getAllSubFolderIds } from 'owa-folders';
import deleteFolder from 'owa-mail-folder-store/lib/actions/deleteFolder';
import { lazyRemoveFolderIdFromMoveToMruList } from 'owa-mail-move-mru';
import folderStore from 'owa-folders';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Called on folders deleted
 * @param folderIds the folder ids that have been deleted
 * @param state the state which contains the favorite ids
 * @param deletedItemsFolderId deleted items folder id of corresponding mailbox
 */
export default action('deleteFolderInFolderForest')(select({
    favoritesFolderNodes: function () { return favoritesStore.favoritesFolderNodes; },
    folders: function () { return folderStore; },
})(function deleteFolderInFolderForest(folderId, actionSource, deletedItemsFolderId, isFolderUnderDeletedItemFolder, state) {
    var _this = this;
    var favoritesFolderNodes = state.favoritesFolderNodes, folders = state.folders;
    var folderIdsToDelete = getAllSubFolderIds(folderId);
    // Only need to worry about removing the top-most folder from its parent's
    // list of children
    var folderToDelete = folders.folderTable.get(folderId);
    // TODO: VSO 8717: Show a different dialog when deleting a folder when folder with the same name exists under deleted items folder of
    // primary or archive mailbox
    var confirmationSubText = isFolderUnderDeletedItemFolder
        ? strings.confirmPermanentDeleteFolderSubText
        : strings.confirmDeleteFolderSubText;
    // Popout the confirmation dialog
    confirm(strings.confirmDeleteFolderText, format(confirmationSubText, folderToDelete.DisplayName)).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (response === DialogResponse.ok) {
                folderIdsToDelete.forEach(function (id) {
                    // Try remove the folder id from the favorites if it's in favorites
                    tryRemoveFromFavorites(id, favoritesFolderNodes, actionSource);
                    // Reset selection to inbox if we are deleting selected folder or if it is a part of subtree being deleted
                    if (id == getFolderIdForSelectedNode()) {
                        selectFolder(folderNameToId('inbox'), 'primaryFolderTree' /* treeType */);
                    }
                });
                // Remove the folder from the folder store and sends out deleteFolder service request
                return [2 /*return*/, deleteFolder(folders, folderId, isFolderUnderDeletedItemFolder /* softDelete */, deletedItemsFolderId)];
            }
            return [2 /*return*/];
        });
    }); });
    // Update move to folder mru list
    lazyRemoveFolderIdFromMoveToMruList.importAndExecute(folderId);
}));
/**
 * Try remove the id from favorite folder ids if it's in the list
 * @param folderIds the folder ids that have been deleted
 * @param favoritesFolderNodes the favorite nodes
 */
function tryRemoveFromFavorites(idToRemove, favoritesFolderNodes, actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var removeFavoriteFolder;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!favoritesFolderNodes.has(idToRemove)) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyRemoveFavoriteFolder.import()];
                case 1:
                    removeFavoriteFolder = _a.sent();
                    removeFavoriteFolder(idToRemove, actionSource);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=deleteFolderInFolderForest.js.map